import React from 'react';
import { FileBadge2, FileText, FileSpreadsheet } from 'lucide-react';

export const CATEGORIES = ['Policy', 'Product Guide', 'Training', 'Legal', 'HR', 'Finance', 'Other'];
export const ALLOWED_EXTS = ['.pdf', '.docx', '.csv'];

export function formatBytes(b: number | null) {
  if (!b) return '-';
  if (b < 1024) return `${b} B`;
  if (b < 1048576) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1048576).toFixed(1)} MB`;
}

export function getFileMeta(name: string | null) {
  const ext = (name || '').split('.').pop()?.toLowerCase();
  if (ext === 'pdf')  return { icon: <FileBadge2 size={18} />,    color: '#EF4444', label: 'PDF' };
  if (ext === 'docx') return { icon: <FileText size={18} />,       color: '#3B82F6', label: 'DOCX' };
  if (ext === 'csv')  return { icon: <FileSpreadsheet size={18} />, color: '#10B981', label: 'CSV' };
  return { icon: <FileText size={18} />, color: '#64748b', label: 'File' };
}

export function validateFile(file: File): string | null {
  const ext = '.' + file.name.split('.').pop()?.toLowerCase();
  if (!ALLOWED_EXTS.includes(ext)) return 'Only PDF, DOCX, and CSV files are allowed.';
  if (file.size > 20 * 1024 * 1024) return 'File size must be under 20 MB.';
  return null;
}

export const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid',
  outline: 'none', transition: 'all 0.2s', fontWeight: 500, boxSizing: 'border-box', fontSize: '14px',
  backgroundColor: 'var(--admin-input-bg, transparent)',
  borderColor: 'var(--admin-input-border, var(--admin-card-border))',
  color: 'var(--admin-card-text)',
  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
};
